import { connect } from 'react-redux';
import { getCompositeLookUpData } from 'shared/Actions/AccOpeningActions';
import { updateProfileFinancialInformations, clearExistingActions } from 'shared/Actions/ProfileSettingsAction';
import { analyzeClickEvent, linkResponseError } from 'shared/Actions/AnalyticsActions';
import { withNotification } from 'modules/CustomerManagementModule/Hoc';
import FinancialInfoComponent from './FinancialInfoComponent';

export const mapStateToProps = state => {
    const { profileInformationData, masterLookUpData } = state;
    const { isError } = profileInformationData;
    return {
        masterLookupStateData: masterLookUpData,
        profileInformationData,
        notify: isError,
        message: {
            message: null,
            info: null,
        },
    };
};

const mapDispatchToProps = {
    getCompositeLookUpData,
    updateProfileFinancialInformations,
    clearExistingActions,
    analyzeClickEvent, 
    linkResponseError
};

export default connect(mapStateToProps, mapDispatchToProps)(withNotification(FinancialInfoComponent));
